const About = () => {
  return null;
};

export default About;
